import React from 'react';
import '../css/ui/Gallery.scss';
import Holder from '../assets/empty.png';
import KTween from '../core/KTween';
import {GalleryArrow} from './Vectors';

type Props =
{
	images:any[],
	className?:any
}
export class Gallery extends React.Component<Props>
{

	state = {
		position: 0
	}

	container:HTMLDivElement;
	imagesContainer:HTMLDivElement;
	holder:HTMLDivElement;
	holderURL;

	_initPoint = {x: 0, y: 0};
	_initPosition = 0;

	componentDidMount()
	{
		this.imagesContainer.addEventListener('mousedown', this._touchStart);
		this.imagesContainer.addEventListener('touchstart', this._touchStart);
	}

	componentWillUnmount()
	{
		KTween.remove(this);
		this.removeEvents();
	}

	get position()
	{
		return this.state.position;
	}

	set position(value)
	{
		if(value < 0) value = 0;
		else if (value > this.props.images.length - 1) value = this.props.images.length - 1;
		if(this.state.position != value) this.setState({position: value});
	}

	private addMouseEvents()
	{
		window.addEventListener('mousemove', this._touchMove);
		window.addEventListener('mouseup', this._touchUp);
		window.addEventListener('mouseleave', this._touchUp);
	}

	private addTouchEvents()
	{
		window.addEventListener('touchmove', this._touchMove);
		window.addEventListener('touchend', this._touchUp);
	}

	private removeEvents()
	{
		window.removeEventListener('mousemove', this._touchMove);
		window.removeEventListener('mouseup', this._touchUp);
		window.removeEventListener('mouseleave', this._touchUp);
		window.removeEventListener('touchmove', this._touchMove);
		window.removeEventListener('touchend', this._touchUp);
	}

	private _touchStart = (e) =>
	{
		if(e.type == 'mousedown')
		{
			this.addMouseEvents();
		}else{
			this.addTouchEvents();
		}

		this._initPosition = this.position;
		let px = e.screenX || e.touches[0]?.screenX;
		let py = e.screenY || e.touches[0]?.screenY;
		this._initPoint = {x: px, y: py};
	}

	private _touchMove = (e) =>
	{
		let bounds = this.holder.getBoundingClientRect();
		let px = e.screenX || e.touches[0]?.screenX;
		let py = e.screenY || e.touches[0]?.screenY;
		let p = {x: px, y: py};
		this.position = this._initPosition + (this._initPoint.x - p.x) / bounds.width;
	}

	private _touchUp = (e) =>
	{
		this.removeEvents();
		let d = this.position - this._initPosition;
		if(Math.abs(d) > 0.2)
		{
			let p = this._initPosition;
			if(d > 0)
			{
				p += 1;
			}else
			{
				p -= 1;
			}
			this.goto(p);
		}else
		{
			this.goto(this._initPosition);
		}
	}

	goto(position)
	{
		position = Math.round(position);

		KTween.remove(this);
		KTween.tween(this, {position: position}, 'easeInOutQuart', 0.3);
	}

	render()
	{
		let className = ['gallery'];
		if(this.props.className) className = className.concat(this.props.className);

		let images = [];
		let bullets = [];
		let w = 0;
		let h = 0;
		this.props.images.forEach((item, i) => {
			let classes = ['bullet'];
			if(item.width > w) w = item.width;
			if(item.height > h) h = item.height;
			if(i == Math.round(this.state.position)) classes.push('selected');
			images.push((<div key={'image_' + i} className='image' style={{backgroundImage: 'url(' + item.src + ')', left: (i * 100) + '%'}} />));
			bullets.push((<div key={'bullet_' + i} onClick={() => this.goto(i)} className={classes.join(' ')} />));
		});

		if(!this.holderURL)
		{
			let canvas = document.createElement('canvas');
			canvas.setAttribute('width', w.toString());
			canvas.setAttribute('height', h.toString());
			this.holderURL = canvas.toDataURL('image/png');
		}

		return (
			<div ref={r => this.container = r} className={className.join(' ')}>
				<div ref={r => this.imagesContainer = r} className='images' style={{left: (this.state.position * -100) + '%'}}>
					{images}
					<img ref={r => this.holder = r} className='holder' src={this.holderURL} width={w} height={h}></img>
				</div>
				{
					(bullets.length > 1)?(
						<div className='buttons'>
							<div className='bullets'>{bullets}</div>
							<div className='arrows'>
								<div className={'left' + ((this.state.position == 0)?' disabled': '')} onClick={(e)=>{this.goto(this.state.position - 1); e.stopPropagation();}}><GalleryArrow></GalleryArrow></div>
								<div className={'right' + ((this.state.position >= this.props.images.length - 1)?' disabled': '')} onClick={(e)=>{this.goto(this.state.position + 1);e.stopPropagation();}}><GalleryArrow></GalleryArrow></div>
							</div>
						</div>
					):null
				}
			</div>
		)
	}
}